import { useState } from 'react';

export default function AdminPhoto({ src, alt, onZoom, onDownload }) {
  const [downloading, setDownloading] = useState(false);

  if (!src) {
    return <span className="admin-info-value">-</span>;
  }

  const handleDownload = async (e) => {
    e.stopPropagation();
    if (!onDownload || downloading) return;
    setDownloading(true);
    try {
      await onDownload();
    } finally {
      setDownloading(false);
    }
  };

  const handleZoom = (e) => {
    e.stopPropagation();
    onZoom?.();
  };

  return (
    <div className="admin-photo">
      <img
        src={src}
        alt={alt || 'Foto'}
        className="thumb"
        onClick={handleZoom}
      />
      <div className="admin-photo-actions">
        {onZoom && (
          <button
            type="button"
            className="admin-photo-btn"
            onClick={handleZoom}
            aria-label="Ampliar imagen"
            title="Ampliar"
          >
            <span className="material-symbols-outlined">zoom_in</span>
          </button>
        )}
        {onDownload && (
          <button
            type="button"
            className="admin-photo-btn"
            onClick={handleDownload}
            disabled={downloading}
            aria-label="Descargar imagen"
            title={downloading ? 'Descargando…' : 'Descargar'}
          >
            <span className="material-symbols-outlined">
              {downloading ? 'hourglass' : 'download'}
            </span>
          </button>
        )}
      </div>
    </div>
  );
}
